<div
  class="platform-organization-contact-container flex-col-start"
  data-cy="organization-contacts"
>
  <markant-platform-ui-page-header
    class="header"
    data-cy="organization-contact-header"
  >
    {{ 'organization.contact.title' | transloco }}
  </markant-platform-ui-page-header>

  <div class="organisation-contact-content">
    @if (store.isLoading()) {
      <markant-platform-organization-data-skeleton
        class="organization-data"
        data-cy="organization-data-skeleton"
      />
    } @else {
      <markant-platform-organization-data
        class="organization-data"
        data-cy="organization-data"
        [data]="store.organization()"
      />
    }

    <hr class="contact-separator-line" />

    <section
      class="organisation-contacts flex-col-start"
      data-cy="organization-contact-section-list"
    >
      <h4>{{ 'organization.contact.contacts' | transloco }}</h4>

      <div
        class="organization-contact-list"
        data-cy="organization-contact-list"
      >
        @if (store.isLoading()) {
          @for (item of CONTACTS_SKELETON; track $index) {
            <markant-platform-organization-contact-item-skeleton
              class="organization-contact-item"
            />
          }
        } @else {
          @for (item of store.contacts(); let i = $index; track i) {
            <markant-platform-organization-contact-item
              class="organization-contact-item"
              [tabIndex]="0"
              [data]="item"
              [id]="'organization-contact-item-' + i"
              [organization]="store.organization()"
            />
          } @empty {
            <p class="organization-no-contact">
              {{ 'organization.contact.noContacts' | transloco }}
            </p>
          }
        }
      </div>
    </section>
  </div>
</div>
